// extracted by mini-css-extract-plugin
var _1 = "r_HglT";
var _2 = "eEbCma";
var _3 = "EX8teY";
var _4 = "RHTchP";
var _5 = "D7lOQ1";
var _6 = "JQcoAX";
var _7 = "FEk4m2";
var _8 = "JkDJxM";
var _9 = "QP_Brv";
var _a = "Tmmvta";
var _b = "R_SEtJ";
var _c = "dqonM2";
var _d = "slkp3D";
export { _1 as "color-alien", _2 as "color-chinatown", _3 as "color-drive", _4 as "color-indiana", _5 as "ease-transition", _6 as "gradient-titanic-80", _7 as "linear-transition-05", _8 as "link", _9 as "shadow-medium-titanic", _a as "shadow-medium-titanic-hover", _b as "shadow-titanic-1", _c as "shadow-white", _d as "text" }
